import $ from 'jquery';

$(document).ready(() => {
//recherche load more
    function checkLoadButton() {
        $('#load').attr(
            'disabled',
            $('.s').not('.filter').filter('.hide').length === 0
        );
    }

    function loadMoreSearch(){
        let allContents = $('.s');
        let loadButton = $('#load');
        //console.log('allContents', allContents);

        // Au chargement, on affiche les 10 premiers uniquement
        allContents.slice(9).addClass('hide');
        checkLoadButton();

        loadButton.on('click', function() {
            allContents.not('.filter').filter('.hide').slice(0, 9).removeClass('hide');
            checkLoadButton()
        });
    }
    loadMoreSearch();
})

